// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".package-features h4{margin-bottom:.5rem;color:#0f1c3f;color:rgba(15,28,63,var(--text-opacity))}.package-features h4,.package-features ul{font-size:.875rem;line-height:1.25rem;--text-opacity:1}.package-features ul{padding-left:1.25rem;color:#737373;color:rgba(115,115,115,var(--text-opacity));list-style-type:disc}.package-features li::marker{font-size:11px}.try-for-free-page .v-hl-container{width:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
